
export class Brand
{
    brandID: number;
    brandName: string;
}